import React, { useRef, useEffect, useCallback, useState} from 'react';
import Xanadu from 'components/xanadu/Xanadu.js';
import PulledEffects from 'components/pulled/PulledEffects.js';
import PadsContainer from '../pads/PadsContainer.js';
import {
    setTransformationEdgeDragging,
    } from 'actions/index.js';
import SubMidiEffectsComponent from './SubMidiEffectsComponent.js';
import GroupEdges from "components/groups/GroupEdges.js";
import SequencerScale from './SequencerScale.js';
import SequencerContextMenu from "components/dropdowns/SequencerContextMenu.js";
import LinkedParameterVisualizer from 'components/parameters/LinkedParameterVisualizer.js';
import {MODE_TO_HEIGHT, WAVEFORM, PIANO_ROLL, INFO} from 'constants/arrangement-modes.js';
import SendsTrackComponent from 'components/track/SendsTrackComponent.js';
import Mix from 'components/mix/Mix.js';
import ConditionedComponent from 'components/ConditionedComponent.js';
import LFOTrackComponent from 'components/lfo/LFOTrackComponent.js';
import TrackComponent from './TrackComponent.js';
import {
    setSelectedPianoRollSteps,
    setStepsGroupMode,
    setShowPianoRoll} from 'actions/index.js';
import {
    MIX_VIEW,
    ARRANGEMENT_VIEW
} from 'constants/view-modes.js';
import {SEQUENCER_VIEW} from 'constants/view-modes.js';
import KeyListener from '../KeyListener.js';
import {connect} from 'react-redux';
import {useKeyListener} from './useKeyListener.js';
import {
    SOUNDS,
    SEQUENCES,
    PRESETS,
    INSTRUMENTS,
    NOTES} from 'constants/sidebar-view-modes.js';

const StepSequencer = (props) => { 
    const scrollContainer = useRef(undefined);
    let {sequencerEngine} = props;
    let [dropdownPos, setDropdownPos] = useState(undefined);
    let tracksClassName = props.viewMode !== SEQUENCER_VIEW ? "full-view" :
        props.trackFocused !== undefined ? "tracks-container focused" :
        props.stretchTracks ? "tracks-container showing-selector" :
        "tracks-container";

    if (props.isMapping || props.stepsGroupMode) {
        tracksClassName += " mapping";
    }
    
    if (!props.sidebarCollapsed &&
        (props.showSelectorMode ||
         props.sidebarViewMode !== SOUNDS)) {
        tracksClassName += ' showing-selector';
    }

    let stretchTracks = 
        props.showSequences ||
        props.showInstruments ||
        props.showSelectorMode ||
        props.showPresets;
    
    let tracks = sequencerEngine.tracks || [];
    if (props.showingPiano) {
        tracks  = sequencerEngine.tracks[props.selectedTrack];
        if (tracks) {
            tracks = [tracks];
        } else {
            tracks = [];
        }
    }
    useEffect(() => {
        // sub sequence changed so clear group-mode and any selected steps
        props.setSelectedSteps(undefined);
        props.setStepsGroupMode(false);
    }, [sequencerEngine.currentSubSequence]);

    const onContextMenu = useCallback((e) => {
        e.preventDefault();
        e.stopPropagation();
        setDropdownPos({x: e.clientX, y: e.clientY});
    }, [setDropdownPos]);

    return (
        <div
          dropabble="true"
          id="#start"
          onContextMenu={onContextMenu}
          ref={scrollContainer}
          className={tracksClassName}>
          <SequencerContextMenu
            sequencerEngine={sequencerEngine}
            setDropdownPos={setDropdownPos}
            dropdownPos={dropdownPos}/>
          <LinkedParameterVisualizer scrollContainer={scrollContainer}/>
          <Xanadu sequencerEngine={sequencerEngine}/>
          <GroupEdges scrollContainer={scrollContainer} sequencerEngine={sequencerEngine}/>
          <ConditionedComponent
            condition={!props.showingPiano && tracks.length > 0}>
            <LFOTrackComponent
              scrollContainer={scrollContainer}
              sequencerEngine={sequencerEngine}
              envelopesTrack={sequencerEngine.envelopesTrack}
              lfosTrack={props.sequencerEngine.lfosTrack}/>
          </ConditionedComponent>
          <PulledEffects sequencerEngine={props.sequencerEngine}/>
          {tracks
           .filter(
               track =>
                   props.trackFocused === undefined ||
                   props.trackFocused === track.trackNumber)
           .map(
               (track, i) =>
                   <TrackComponent
                     key={track.id}
                     scrollContainer={scrollContainer}
                     track={track}/>
           )}
          
          <PadsContainer
            scrollContainer={scrollContainer}
            sequencerEngine={sequencerEngine}/>
                     
        {!props.showingPiano && tracks.length > 0 ?
         <div className="sub-sequence-control">
           <SendsTrackComponent scrollContainer={scrollContainer} sequencerEngine={sequencerEngine}/>
           <SubMidiEffectsComponent scrollContainer={scrollContainer} sequencerEngine={sequencerEngine}/>
         </div>
             : ''}
        </div>
    );
}

const mapStateToProps = (state, props) => {
    let bottomMode = state.arrangement.bottomMode;
    let showingPiano = state.sequencer.showPianoRoll; // && bottomMode === PIANO_ROLL;
    return {
        showSelectorMode: state.sequencer.showSelectorMode,
        sidebarCollapsed: state.selector.sidebarCollapsed,
        sidebarViewMode: state.sequencer.sidebarViewMode,
        trackFocused: state.sequencer.trackFocused,
        tracks: props.sequencerEngine.tracks,
        numTracks: props.sequencerEngine.tracks &&
            props.sequencerEngine.tracks.length,
        showingPiano, 
        selectedTrack: showingPiano && state.mix.selectedTrack,
        isMapping: state.effects.accumulatorParameterSelected,
        stepsGroupMode: state.groups.stepsGroupMode,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setTransformationEdgeDragging: (x) => dispatch(setTransformationEdgeDragging(x)),
      setSelectedSteps: (x) => dispatch(setSelectedPianoRollSteps(x)),
      setStepsGroupMode: (x) => dispatch(setStepsGroupMode(x))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(StepSequencer);
